import { Languages, Moon, Sun } from 'lucide-react';
import { useI18n, type Language } from '../i18n';
import { useTheme } from '../theme';

const OTHER_LANGUAGE: Record<Language, Language> = { cs: 'en', en: 'cs' };

/** Přepínač light/dark (E11-US7) a jazyka UI (E11-US8) — dostupný z hlavičky aplikace. */
export function PreferencesToolbar() {
  const { theme, toggleTheme } = useTheme();
  const { language, setLanguage, t } = useI18n();
  const nextLanguage = OTHER_LANGUAGE[language];

  return (
    <div className="preferences-toolbar">
      <button
        type="button"
        className="preferences-toolbar__button icon-btn"
        title={theme === 'dark' ? t('theme.toggleToLight') : t('theme.toggleToDark')}
        onClick={toggleTheme}
      >
        {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
      </button>
      <button
        type="button"
        className="preferences-toolbar__button"
        title={t('language.switchTo', { language: t(`language.${nextLanguage}`) })}
        onClick={() => setLanguage(nextLanguage)}
      >
        <Languages size={16} />
        {language.toUpperCase()}
      </button>
    </div>
  );
}
